// extracted by mini-css-extract-plugin
export default {"container":"Best_container__3G660","inner":"Best_inner__MygLE","head":"Best_head__Ez0SZ","title":"Best_title__C1M9X","slider":"Best_slider__PmLwX","item":"Best_item__owM6u"};